import { ca } from '@cian/analytics';
/**
 * СОБЫТИЯ ФЛОУ АВТОРИЗАЦИИ ПО ТЕЛЕФОНУ
 */

/**
 * Клик по ссылке  отправить еще раз
 */

export function trackPhoneAuthResendValidationCode() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'phone_send_again'
  });
}
/**
 * Введен неверный код подтверждения, полученный по СМС
 */

export function trackPhoneAuthSmsValidationFail() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Fail',
    label: 'phone_simple'
  });
}
/**
 * Введен неверный код подтверждения, полученный по телефонному звонку
 */

export function trackPhoneAuthCallValidationFail() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Fail',
    label: 'last_phone_numbers'
  });
}
/**
 * Введен неверный код, превышено кол-во попыток
 */

export function trackPhoneAuthExhausted() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Fail',
    label: 'phone_fatal'
  });
}
/**
 * Клик по кнопке продолжить, после ввода телефона
 */

export function trackPhoneAuthResumeButtonClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'phone_continue'
  });
}
/**
 * Клик по ссылке нужна помощь
 */

export function trackPhoneAuthNeedHelp() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'phone_cant_confirm'
  });
}
/**
 * Показ попапа "На ваш номер поступит бесплатный звонок"
 */

export function trackPhoneAuthCallOnboardingShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'we_call_you_popup_show',
    label: ''
  });
}
/**
 * Клик по "Хорошо, жду звонка!" на экране онбординга
 */

export function trackPhoneAuthCallOnboardingOkClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'we_call_you_popup_click',
    label: ''
  });
}
/**
 * Клик на "получить код через смс" при авторизации/регистрации через звонок
 */

export function trackPhoneAuthCallSwitchToSmsClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click_send_sms',
    label: 'last_phone_numbers'
  });
}